const COLORS = {
  blue: "#6C91BF",
  cream: "#F5F5DC",
  apricot: "#F0E6D2",
  gold: "#D4AF37",
  green: "#7BB661",
  pink: "#E8A9A9",
  orange: "#E9A15B",
  lightBlue: "#8BB8E8",
  red: "#D96C6C",
  text: "#2F3A45",
  subtext: "#6B7280",
  white: "#FFFFFF",
  line: "#E5E7EB",
  soft: "#FAF8F3",
  paleBlue: "#EDF4FB",
  paleGreen: "#EEF8EE",
  palePink: "#FDF1F1",
  paleOrange: "#FFF4EA",
  paleGray: "#F7F7F8",
  overlay: "rgba(0,0,0,0.45)",
};

export default COLORS;